import {
    PHARMACY_SEARCH_DELIVERY_SUPERVISOR_LIST_REQUEST,
    PHARMACY_SEARCH_DELIVERY_SUPERVISOR_LIST_SUCCESS,
    PHARMACY_SEARCH_DELIVERY_SUPERVISOR_LIST_FAILURE,
} from '../../../constants';

const initialState = {
    data: null,
    loading: false,
    error: null,
};

const searchDeliverySupervisorListReducer = (state = initialState, action) => {
    switch (action.type) {
        case PHARMACY_SEARCH_DELIVERY_SUPERVISOR_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                data: null,
                error: null,
            };
        case PHARMACY_SEARCH_DELIVERY_SUPERVISOR_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };
        case PHARMACY_SEARCH_DELIVERY_SUPERVISOR_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                data: null,
            };
        default:
            return state;
    }
};

export default searchDeliverySupervisorListReducer;
